import { Button } from "@/components/ui/button"
import { TrashIcon } from "@heroicons/react/20/solid"
import { useState } from "preact/compat"
import { deleteIntegration } from "@/api/integration"
import { useLocation } from "wouter-preact"
import { loadOrgSettings } from "@/org_settings/state.tsx"

interface DangerZoneProps {
  integrationId: string
  integrationName: string
}

export function DangerZone({ integrationId, integrationName }: DangerZoneProps) {
  const [, setLocation] = useLocation()
  const [deleting, setDeleting] = useState(false)

  async function handleDelete() {
    if (!confirm("Are you sure you want to delete this connection? This action cannot be undone.")) {
      return
    }

    setDeleting(true)
    const res = await deleteIntegration(integrationId)

    setDeleting(false)
    if (res.ok) {
      loadOrgSettings()
      setLocation("/settings/connections")
    }
  }

  return (
    <div class="bg-white border border-red-200 rounded-lg p-4">
      <h2 class="text-sm font-medium text-red-600 mb-2">Danger Zone</h2>
      <p class="text-sm text-gray-500 mb-4">
        Deleting this connection will stop syncing data from {integrationName}.
      </p>
      <Button variant="destructive" onClick={handleDelete} disabled={deleting}>
        <TrashIcon class="h-4 w-4 mr-2" />
        {deleting ? "Deleting..." : "Delete Connection"}
      </Button>
    </div>
  )
}
